import React from 'react'

const HomeIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20"><path d="M9.6 20v-7.059h4.8v7.059h6v-9.412h3.6l-12-10.588-12 10.588h3.6v9.412z" fill="#fff"/></svg>
)

export default HomeIcon